<template>
  <div>
    <div class="row">
      <div
        class="col-md-12 top-button top-buttons-list"
        style="display: inline-flex"
      >
        <div v-if="isPowerUserOrAdministrator">
          <button
            :class="buttonClassObject"
            type="submit"
            class="top-button btn btn-fill btn-wd"
            aria-label="Activer la modification ou enregistrer"
            @click.prevent="buttonClicked"
          >
            <a v-if="editingDisabled">Editer</a>
            <a v-else>Enregister</a>
          </button>
          <button
            v-show="!editingDisabled"
            type="warning"
            class="top-button btn btn-warning btn-fill btn-wd"
            aria-label="Annuler"
            @click.prevent="cancelButtonClicked"
          >
            Annuler
          </button>
          <button
            v-show="!editingDisabled && !newInstitutionCreation"
            type="danger"
            class="top-button btn btn-danger btn-fill btn-wd"
            aria-label="Effacer"
            @click.prevent="deleteButtonClicked"
          >
            Effacer
          </button>
        </div>
        <div
          v-show="editingDisabled && !newInstitutionCreation"
          class="export-dropdown"
        >
          <drop-down>
            <p-button
              slot="title"
              slot-scope="{ isOpen }"
              :aria-expanded="isOpen"
              type="primary"
              round
              block
              class="dropdown-toggle"
              aria-label="Ouvrir possibilité d'exporter"
            >
              Exporter
            </p-button>
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="exportToCsvIEButtonClicked"
              >Internet Explorer TXT</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="exportToCsvOtherButtonClicked"
              >Autres TXT</a
            >
          </drop-down>
        </div>
        <p class="institution-error-message">{{ institutionErrorMessage }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Données de base</h5>
          </div>
          <div class="card-body">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <fg-input
                    v-validate="'required'"
                    :disabled="editingDisabled"
                    v-model="institution.name"
                    data-vv-scope="formInstitutionDetails"
                    name="nom"
                    type="text"
                    label="Nom"
                  />
                  <span>{{ errors.first('formInstitutionDetails.nom') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <fg-input
                    :disabled="editingDisabled"
                    v-model="institution.acronym"
                    type="text"
                    label="Acronyme"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <fg-input
                    :disabled="editingDisabled"
                    v-model="institution.accountno"
                    type="text"
                    label="Relation financière"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Notes</h5>
          </div>
          <div class="card-body">
            <div class="col-md-12">
              <div class="form-group">
                <textarea
                  :disabled="editingDisabled"
                  v-model="institution.notes"
                  rows="6"
                  class="form-control border-input notes"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="!newInstitutionCreation" class="card">
          <div class="card-header">
            <h5 class="title">Données complémentaires</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <tabs value="Description" tab-content-classes="text-center">
                  <tab-pane key="people" title="Personnes">
                    <people-institution-list
                      v-if="isTargetInstitutionSet"
                      :editing-disabled="editingDisabled"
                      :linked-institution-id="targetInstitutionId"
                    />
                  </tab-pane>
                  <tab-pane key="departments" title="Départements">
                    <departments-cards
                      :departments="institution.departments"
                      :editing-disabled="editingDisabled"
                      :linked-institution-id="targetInstitutionId"
                      :fetch="fetchInstitutionById"
                    />
                  </tab-pane>
                  <tab-pane key="communication" title="Communication">
                    <means-of-telecom-cards
                      :means-of-telecom="institution.telecomInfos"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetInstitutionId"
                      :fetch="fetchInstitutionById"
                    />
                  </tab-pane>
                  <tab-pane key="addresses" title="Adresses">
                    <addresses-cards
                      :addresses="institution.addresses"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetInstitutionId"
                      :fetch="fetchInstitutionById"
                    />
                  </tab-pane>
                  <tab-pane key="themes" title="Thèmes">
                    <profiles-cards
                      :profiles="institution.profiles"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetInstitutionId"
                      :fetch="fetchInstitutionById"
                    />
                  </tab-pane>
                </tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  canUserAccessPrivateData,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';
import { Tabs, TabPane } from 'src/components/UIComponents';
import PeopleInstitutionList from 'src/components/ApplicationViews/UIComponents/PeopleInstitutionList.vue';
import DepartmentsCards from 'src/components/ApplicationViews/UIComponents/DepartmentsCards.vue';
import MeansOfTelecomCards from 'src/components/ApplicationViews/UIComponents/MeansOfTelecomCards.vue';
import AddressesCards from 'src/components/ApplicationViews/UIComponents/AddressesCards.vue';
import ProfilesCards from 'src/components/ApplicationViews/UIComponents/ProfilesCards.vue';

import EventBus from 'src/event-bus';
import swal from 'sweetalert2';
import { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';

export default {
  components: {
    TabPane,
    Tabs,
    PeopleInstitutionList,
    DepartmentsCards,
    MeansOfTelecomCards,
    AddressesCards,
    ProfilesCards,
  },
  data() {
    return {
      editingDisabled: true,
      targetInstitutionId: 0,
      newInstitutionCreation: false,
      currentPage: 0,
      institution: {},
      currentOperation: '',
      institutionErrorMessage: '',
      personErrorMessage: '',
      type: 'institutions',
    };
  },
  computed: {
    canUserAccessPrivateData,
    isPowerUserOrAdministrator,
    isTargetInstitutionSet() {
      return this.targetInstitutionId !== 0;
    },
    buttonClassObject() {
      return {
        'btn-warning': this.editingDisabled,
        'btn-success': !this.editingDisabled,
      };
    },
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        this.newInstitutionCreation = newValue.params.newInstitutionCreation;
        if (this.newInstitutionCreation) {
          this.editingDisabled = false;
        } else {
          this.targetInstitutionId = parseInt(this.$route.params.id, 10);
          this.fetchInstitutionById(this.targetInstitutionId);
        }
      },
      deep: true,
    },
  },
  created() {
    this.newInstitutionCreation = this.$route.params.newInstitutionCreation;
    if (this.newInstitutionCreation) {
      this.editingDisabled = false;
    } else {
      this.targetInstitutionId = parseInt(this.$route.params.id, 10);
      this.fetchInstitutionById(this.targetInstitutionId);
    }
  },
  mounted() {
    // Set the field validator to french
    Validator.localize('fr', fr);
    EventBus.$on('search', this.searchInstitutions);
  },
  beforeDestroy() {
    EventBus.$off('search', this.searchInstitutions);
  },
  beforeRouteUpdate(to, from, next) {
    this.targetInstitutionId = parseInt(to.params.id, 10);
    this.fetchInstitutionById(this.targetInstitutionId);
    next();
  },
  methods: {
    searchInstitutions(searchText) {
      this.$router.push({
        name: 'Institutions',
        params: { searchText },
      });
    },
    buttonClicked() {
      if (this.newInstitutionCreation) {
        // Validate that the required field are filled before creating record
        this.$validator.validateAll('formInstitutionDetails').then(result => {
          if (result) {
            this.createRecordInstitution();
            this.newInstitutionCreation = !this.newInstitutionCreation;
          } else {
            this.institutionErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else if (!this.editingDisabled) {
        // Validate that the required field are filled before updating record
        this.$validator.validateAll('formInstitutionDetails').then(result => {
          if (result) {
            this.updateRecordInstitution();
            this.editingDisabled = !this.editingDisabled;
          } else {
            this.institutionErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else {
        this.editingDisabled = !this.editingDisabled;
      }
    },
    deleteButtonClicked() {
      swal({
        title: 'Êtes-vous sûr de vouloir supprimer cette institution ?',
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.deleteRecordInstitution();
      });
    },
    cancelButtonClicked() {
      if (this.newInstitutionCreation) {
        this.$router.push({
          name: 'Institutions',
        });
      } else {
        this.editingDisabled = true;
        this.fetchInstitutionById(this.targetInstitutionId);
      }
    },
    doExportTxtRequest() {
      let url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/txt/`;

      if (this.canUserAccessPrivateData) {
        url += 'private';
      } else {
        url += 'public';
      }

      url += `/institutiondetails/${this.targetInstitutionId}/`;

      return this.$http.get(url);
    },
    exportToCsvIEButtonClicked() {
      if (window.navigator.msSaveBlob) {
        this.doExportTxtRequest()
          .then(response => {
            const BOM = '\uFEFF';
            const blobObject = new Blob([BOM + response.data]);

            // Filename
            const headerContent = response.headers['content-disposition'];
            const startFileNameIndex = headerContent.indexOf('"') + 1;
            const endFileNameIndex = headerContent.lastIndexOf('"');
            const filename = headerContent.substring(
              startFileNameIndex,
              endFileNameIndex,
            );

            window.navigator.msSaveBlob(blobObject, `${filename}.txt`);
            // Or msSaveOrOpenBlob
          })
          .catch(error => {
            this.institutionErrorMessage =
              "Une erreur s'est produite lors de l'exportation, veuillez réessayer ou contacter le support.";
          });
      } else {
        this.institutionErrorMessage =
          'Cette fonctionnalité est uniquement disponible sur le navigateur Internet Explorer, veuillez exporter "Autres TXT".';
      }
    },
    exportToCsvOtherButtonClicked() {
      this.doExportTxtRequest()
        .then(response => {
          const BOM = '\uFEFF';
          const url = window.URL.createObjectURL(
            new Blob([BOM + response.data]),
          );
          // Filename
          const headerContent = response.headers['content-disposition'];
          const startFileNameIndex = headerContent.indexOf('"') + 1;
          const endFileNameIndex = headerContent.lastIndexOf('"');
          const filename = headerContent.substring(
            startFileNameIndex,
            endFileNameIndex,
          );

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}.txt`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          this.institutionErrorMessage =
            "Une erreur s'est produite lors de l'exportation, veuillez réessayer ou contacter le support.";
        });
    },
    fetchInstitutionById(id) {
      const dto = this.canUserAccessPrivateData ? 'DTO' : 'PublicDTO';

      return this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/institutionEntities/${id}?projection=institution${dto}`,
        )
        .then(response => {
          this.institution = response.data;
        });
    },
    createRecordInstitution() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/`,
          {
            name: this.institution.name,
            acronym: this.institution.acronym,
            accountno: this.institution.accountno,
            notes: this.institution.notes,
          },
        )
        .then(response => {
          this.institution.id = response.data;
          this.institutionErrorMessage = '';
          this.newInstitutionCreation = !this.newInstitutionCreation;
          this.editingDisabled = !this.editingDisabled;
          this.$router.push({
            name: 'InstitutionDetails',
            params: { id: this.institution.id, newInstitutionCreation: false },
          });
        })
        .catch(error => {
          this.institutionErrorMessage =
            "Une erreur est survenue lors de la création de l'institution, veuillez réessayer ou contacter le support.";
        });
    },
    updateRecordInstitution() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${this.institution.id}`,
          {
            name: this.institution.name,
            acronym: this.institution.acronym,
            accountno: this.institution.accountno,
            notes: this.institution.notes,
          },
        )
        .then(response => {
          this.fetchInstitutionById(this.institution.id);
          this.institutionErrorMessage = '';
        })
        .catch(error => {
          this.institutionErrorMessage =
            "Une erreur est survenue lors de l'édition de l'institution, veuillez réessayer ou contacter le support.";
        });
    },
    deleteRecordInstitution() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/institutions/${this.institution.id}`,
        )
        .then(response => {
          this.institutionErrorMessage = '';
          this.$router.push({
            name: 'Institutions',
          });
        })
        .catch(error => {
          this.institutionErrorMessage =
            "Une erreur est survenue lors de la suppression de l'institution, veuillez réessayer ou contacter le support.";
        });
    },
  },
};
</script>

<style scoped>
.clickable-element {
  cursor: pointer;
}

textarea.form-control.notes {
  max-height: none;
}

.institution-error-message {
  margin-top: 10px;
  margin-left: 200px;
  padding-top: 10px;
  color: darkred;
}

.export-dropdown {
  position: absolute;
  right: 20px;
}
.form-address-street {
  width: 100%;
}

#btn-add {
  position: absolute;
  right: 20px;
  top: 62px;
  margin: 0px;
}

#btn-export {
  position: absolute;
  right: 10px;
  top: 10px;
  margin: 0px;
}

.validation-error {
  color: red;
}

.top-buttons-list {
  min-height: 60px;
}
</style>
